import { ContainerModule } from 'inversify';
import * as Store from './store';
import * as Service from './service';
import { PlayerModuleSymbol } from '../api';
import { QuizSessionPlayerModule } from './quiz-session-player-module';
import { QuizSessionReducerPluginFactorySymbol, QuizSessionReducerPlugin, QuizSessionReducerPluginSymbol } from './api';

const quizSessionModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(QuizSessionPlayerModule)

  bind(QuizSessionReducerPluginFactorySymbol).toFactory<QuizSessionReducerPlugin>(c => {
    return (name: string) => {
      if (c.container.isBoundNamed(QuizSessionReducerPluginSymbol, name)) {
        return c.container.getNamed(QuizSessionReducerPluginSymbol, name)
      }

      throw new Error(`Coding error: QuizSessionReducerPlugin not found with name '${name}'`)
    }

  })
  
});

export const quizSessionModules = [
  quizSessionModule,
  Service.quizSessionServiceModule,
  Store.quizSessionStateModule
]
